// extracted by mini-css-extract-plugin
export default {"button":"Ap-z","reviewSort":"Bp-z"};